var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1248_1110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1248_1110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0937 5.22393L21.5864 5.37728C23.3536 5.57702 24.6806 7.08535 24.6536 8.8635V17.2468C24.6806 19.025 23.3536 20.5332 21.5864 20.7331L20.1551 20.8864C15.689 21.3463 11.1873 21.3463 6.72109 20.8864L5.22842 20.7331C3.46125 20.5332 2.13425 19.025 2.16129 17.2468V8.8635C2.13425 7.08535 3.46125 5.57702 5.22842 5.37728L6.65974 5.22393C11.1259 4.7639 15.6276 4.7639 20.0937 5.22393ZM12.4975 16.347L16.4745 13.689H16.5359C16.7502 13.5494 16.8795 13.3109 16.8795 13.0551C16.8795 12.7994 16.7502 12.5609 16.5359 12.4213L12.5589 9.76315C12.324 9.60444 12.0208 9.58819 11.7704 9.72089C11.52 9.8536 11.3632 10.1136 11.3627 10.397V15.7133C11.3759 15.977 11.5239 16.2155 11.7546 16.3443C11.9852 16.4732 12.2659 16.4743 12.4975 16.347Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1248_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8024,
    height: 24.5625,
    fill: "white",
    transform: "translate(0.787842 0.787109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1248_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7893,
    height: 24.5364,
    fill: "white",
    transform: "translate(0.788818 0.786621)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.119d4a1860099b1c0b7cfb2749ecb663.svg";
export { ForwardRef as ReactComponent };